import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { RespiratoryConstant } from '../respiratory/store/respiratory.constant'
import { PulsesConstants } from '../cardio/pulses/store/pulses.constants'
import { initialPulsesState } from '../cardio/pulses/store/pulses.reducer'
import { getSelectedDataFromObject } from '../../../utilities/data.util'
import { respiratoryStatePrNabc } from '../respiratory/store/respiratory.reducers'
import { getRespiratorySelector } from '../respiratory/selectors'
import { IRespiratoryState } from '../respiratory/store/respiratory.types'
import { getPulsesSelector } from '../cardio/pulses/selectors'
import { IPulsesState } from '../cardio/pulses/store/pulses.types'
import { MotorSensoryAssessmentConstants } from '../neuro/motorSensoryAssessment/store/motoSensoryAssessment.constants'
import { PupilsConstants } from '../neuro/pupils/store/pupils.constants'
import { NeuroConstants } from '../neuro/store/neuro.constants'
import { initialMotorSensoryAssessmentState } from '../neuro/motorSensoryAssessment/store/motoSensoryAssessment.reducers'
import { IMotorSensoryAssessmentState } from '../neuro/motorSensoryAssessment/store/motoSensoryAssessment.types'
import { getMotorSensoryAssessmentSelector } from '../neuro/motorSensoryAssessment/selectors'
import { getNeuroSelector } from '../neuro/selectors'
import { INeuroState } from '../neuro/store/neuro.types'
import { neuroPrNabc } from '../neuro/store/neuro.reducers'
import { getPupilsSelector } from '../neuro/pupils/selectors'
import { IPupilsState } from '../neuro/pupils/store/pupils.types'
import { initialPupilsState } from '../neuro/pupils/store/pupils.reducers'
import { ICardioState } from '../cardio/store/cardio.types'
import { getInitialAssessmentCardio } from '../cardio/selectors/getInitialAssessmentCardio.selectors'
import { CardioConstants } from '../cardio/store/cardio.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setCmdFacChartDefaults() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const respData: IRespiratoryState = yield select(getRespiratorySelector)
  const motorSensoryAssessment: IMotorSensoryAssessmentState = yield select(getMotorSensoryAssessmentSelector)
  const pulses: IPulsesState = yield select(getPulsesSelector)
  const neuro: INeuroState = yield select(getNeuroSelector)
  const pupils: IPupilsState = yield select(getPupilsSelector)
  const initalAssessmentCardio: ICardioState = yield select(getInitialAssessmentCardio)

  const pulsesItems = getSelectedDataFromObject(pulses, Object.keys(initialPulsesState))
  const respItems = getSelectedDataFromObject(respData, Object.keys(respiratoryStatePrNabc))
  const motorSensoryAssessmentItems = getSelectedDataFromObject(
    motorSensoryAssessment,
    Object.keys(initialMotorSensoryAssessmentState)
  )
  const neuroItems = getSelectedDataFromObject(neuro, Object.keys(neuroPrNabc))
  const pupilsItems = getSelectedDataFromObject(pupils, Object.keys(initialPupilsState))
  try {
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        prNabc: {
          ...pcrDoc.prNabc,
          ...pulsesItems,
          ...respItems,
          ...motorSensoryAssessmentItems,
          ...neuroItems,
          ...pupilsItems,
          ...initalAssessmentCardio.prNabc,
        },
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    }
  } catch (e) {
    yield put(throwPcrException(`setCmdFacChartDefaults() error: ${e}`))
  }
}

export function* setCmdFacChartDefaultsSaga() {
  yield takeLatest(
    [
      MotorSensoryAssessmentConstants.SET_MOTOR_SENSORY,
      PupilsConstants.SET_PUPILS,
      NeuroConstants.SET_NEURO,
      RespiratoryConstant.SET_RESPIRATORY,
      PulsesConstants.SET_PULSES,
      CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO_NABC,
    ],
    performWithMutexHOG,
    setCmdFacChartDefaults
  )
}
